import React, { type JSX } from "react";
import { SupListTable, SupListRow } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

import { SupTxValue } from "../TxValue";
import type { TxStatus, TxValueProps } from "../types";

import { TxPhase } from "./components/Phase";

export interface TxDetailsProps {
  className?: string;
  notification?: JSX.Element;
  data: TxValueProps[];
  phases: { status: TxStatus; data: TxValueProps[] }[];
}

export function SupTxDetails({ className, notification, data, phases }: TxDetailsProps) {
  return (
    <div className={twMerge("flex flex-col gap-6", className)}>
      <SupListTable header={notification}>
        {data.map((row, i) => (
          <SupListRow key={i} label={row.label} value={<SupTxValue {...row} />} />
        ))}
      </SupListTable>

      {phases.map(({ status, data }, index) => (
        <TxPhase key={index} index={index + 1} status={status} data={data} />
      ))}
    </div>
  );
}
